<template>
  <div class="nav-bar">
    <div style="float: right;margin-right: 20px;">
      <el-dropdown>
        <span class="el-dropdown-link">欢迎您，{{username}}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>占位</el-dropdown-item>
          <span style="display: block;" @click="handleLogout">
            <el-dropdown-item divided icon="el-icon-user">退出登录</el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data () {
    return {
      username: this.$store.getters.username
    }
  },
  methods: {
    handleLogout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }
}
</script>

<style scoped>
  .nav-bar {
    height: 60px;
    line-height: 60px;
    border-radius: 0 !important;
    box-shadow: 0 1px 10px rgba(0, 21, 20, .12);
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
</style>
